import { Pipe, PipeTransform } from '@angular/core';
import {DatePipe} from "@angular/common";

@Pipe({
  name: 'spotfightDateFormat',
  standalone: true
})
export class SpotfightDateFormatPipe extends DatePipe implements PipeTransform {


  override transform(value: any, args?: any): any {
    return super.transform(value, "dd.MM.yyyy HH:mm", 'de');
  }

}
